const state = {
  clubs: [
    {
      name: 'Kuntokeskus CrossGym',
      id: 1,
      location: 'Kuntokeskus CrossGym',
      queryName: 'crossgym',
      genetive: 'CrossGymin',
      partitive: 'Kuntokeskus CrossGymiä',
      imageUrl:
        'https://www.kuntokeskuscrossgym.fi/wp-content/uploads/2023/03/crossgym-sali.jpg',
      clubLevel: 3,
      services: [
        {
          name: 'Kuntosali',
          id: 1,
        },
        {
          name: 'Ryhmäliikunta',
          id: 2,
        },
      ],
      whatYouGet:
        'Lataamalla tämän passin ja näyttämällä sitä vastaanotossa, pääset kokeilemaan salia kerran ilmaiseksi!',
      hours: ['Ma-to klo 15-18'],
      mautic: {
        tag: 'kokeilupassi',
        segmentID: 4,
        campaignID: 4,
      },
      buttons: [
        {
          text: 'CrossGymin etusivu',
          blank: false,
          link: 'https://www.kuntokeskuscrossgym.fi/',
          featured: true,
          iconClass: 'bxs-home',
        },
        {
          text: 'Katso sijainti kartalta',
          blank: true,
          link:
            'https://www.google.fi/maps/place/Kuntokeskus+CrossGym/@61.1992621,26.0552883,17z/data=!3m1!4b1!4m5!3m4!1s0x469029b1fc0ea79f:0x36de95268b39820e!8m2!3d61.1992621!4d26.057477',
          featured: false,
          iconClass: 'bxs-navigation',
        },
      ],
      errorBtn: {
        text: 'Asiakkuudet',
        blank: false,
        link: 'https://www.kuntokeskuscrossgym.fi/hinnasto/',
        featured: true,
        iconClass: 'bxs-id-card',
      },
      shares: {
        facebook:
          'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcrossgym.lataapassi.fi',
        messenger:
          'fb-messenger://share/?link=https%3A%2F%2Fcrossgym.lataapassi.fi',
        whatsapp:
          'whatsapp://send?text=Moi%21%0A%0AT%C3%A4m%C3%A4n%20passin%20avulla%20p%C3%A4%C3%A4set%20kokeilemaan%20Kuntokeskus%20CrossGymi%C3%A4%20ilmaiseksi%21%20Lataa%20passi%20s%C3%A4hk%C3%B6postiisi%20t%C3%A4%C3%A4lt%C3%A4%3A%20https%3A%2F%2Fcrossgym.lataapassi.fi%0A%0ATutustu%20CrossGymiin%20tarkemmin%3A%20https%3A%2F%2Fwww.kuntokeskuscrossgym.fi%2F',
        email:
          'mailto:?subject=CrossGymin%20ilmainen%20kokeilu%21&body=Moi%21%0A%0AT%C3%A4m%C3%A4n%20passin%20avulla%20p%C3%A4%C3%A4set%20kokeilemaan%20Kuntokeskus%20CrossGymi%C3%A4%20ilmaiseksi%21%20Lataa%20passi%20s%C3%A4hk%C3%B6postiisi%20t%C3%A4%C3%A4lt%C3%A4%3A%20https%3A%2F%2Fcrossgym.lataapassi.fi%0A%0ATutustu%20CrossGymiin%20tarkemmin%3A%20https%3A%2F%2Fwww.kuntokeskuscrossgym.fi%2F',
      },
    },
  ],
  selectedClub: {},
  hasSelected: false,
}

const getters = {
  allClubs: (state) => state.clubs,
  getSelectedClub: (state) => state.selectedClub,
  hasSelectedClub: (state) => state.hasSelected,
};

const actions = {
  selectClub({ commit }, id) {
    commit("setSelectedClub", id);
  },
  selectClubByQueryName({ commit }, queryName) {
    commit("setSelectedClubByQueryName", queryName);
  },
};

const mutations = {
  setSelectedClub: (state, id) => {
    const index = state.clubs.findIndex((club) => club.id === id);
    if (index !== -1) {
      state.selectedClub = state.clubs[index];
      state.hasSelected = true;
    }
  },
  setSelectedClubByQueryName: (state, queryName) => {
    const index = state.clubs.findIndex((club) => club.queryName === queryName);
    if (index !== -1) {
      state.selectedClub = state.clubs[index];
      state.hasSelected = true;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
